import React from 'react';
import { injectIntl } from 'react-intl';
import { Clearfix, ButtonGroup, Button, Overlay, Popover } from 'react-bootstrap';

import { getThumbFile } from 'helpers/items';

class CmsMediaSelectorFilePreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDelete: false,
      showPlayer: false,
    };

    this.containerRef = React.createRef();
    this.videoRef = React.createRef();
  }

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };

  onSelect = e => {
    e.preventDefault();
    e.stopPropagation();

    const { file, onSelect } = this.props;

    onSelect(file.id);
  };

  onDirectSelect = e => {
    e.preventDefault();
    e.stopPropagation();

    const { file, onDirectSelect } = this.props;

    onDirectSelect(file.id);
  };

  onDelete = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ showDelete: true });
  };

  closeDelete = () => {
    this.setState({ showDelete: false });
  };

  doDelete = () => {
    const { file, onDelete } = this.props;

    this.setState({ showDelete: false }, () => {
      onDelete(file.id);
    });
  };

  onMouseEnter = () => {
    this.timeout = setTimeout(this.setMouseOverState, 1000);
  };

  setMouseOverState = () => {
    const { mediaType } = this.props;

    if (mediaType === 'video') {
      this.setState({ showPlayer: true }, () => {
        if (this.videoRef.current) {
          this.videoRef.current.play();
        }
      });
    }
  };

  onMouseLeave = () => {
    const { mediaType } = this.props;
    const { showPlayer } = this.state;

    clearTimeout(this.timeout);

    if (mediaType === 'video' && showPlayer) {
      if (this.videoRef.current) {
        this.videoRef.current.pause();
      }
    }
  };

  render() {
    const {
      intl: { messages },
      file,
      mediaType,
      selected,
    } = this.props;
    const { showPlayer, showDelete } = this.state;

    let background = {};
    let isVideoUploaded = false;
    let videoThumbUrl = null;

    switch (mediaType) {
      case 'video': {
        if (file.video_info) {
          isVideoUploaded = file.video_info.thumb_transcoding_finished && file.video_info.web_transcoding_finished;
          videoThumbUrl = file.video_info.thumb_link;
        }
        break;
      }

      default: {
        const thumbFile = getThumbFile(file);
        if (thumbFile || file.web_link) {
          background = {
            ...background,
            backgroundImage: 'url(' + ((thumbFile && thumbFile.web_link) || file.web_link) + ')',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          };
        }
      }
    }

    return (
      <>
        <div
          ref={this.containerRef}
          className={'gallery-item relative no-margin ' + (selected ? 'b-a b-thick b-primary ' : '')}
          style={{
            height: '100%',
            width: '100%',
            backgroundColor: 'transparent',
            backgroundImage: mediaType === 'image' ? 'url(/img/checkered.png)' : 'none',
          }}
          onClick={this.onDirectSelect}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          {mediaType === 'image' && <div className="top-left bottom-right" style={background} />}
          {mediaType === 'video' && (
            <div className="top-left bottom-right">
              {showPlayer && isVideoUploaded ? (
                <video autoPlay loop ref={this.videoRef}>
                  <source src={videoThumbUrl} type="video/mp4" />
                </video>
              ) : (
                <div className="text-center p-t-20">
                  <i className="fad fa-play" />
                </div>
              )}
            </div>
          )}

          <div className="overlayer bottom-left full-width">
            <div className="overlayer-wrapper item-info ">
              <div className="gradient-grey p-l-10 p-r-10 p-t-20 p-b-5">
                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <p className="bold text-white fs-11 p-t-10" style={{ whiteSpace: 'nowrap' }}>
                    {file.file_name}
                  </p>
                </div>
                <div className="m-t-10">
                  <Clearfix className="fs-11 text-center">
                    <i className="text-white fal fa-2x fa-edit cursor m-r-10" onClick={this.onSelect} />
                    <i className="text-white fal fa-2x fa-trash-alt cursor" onClick={this.onDelete} />
                  </Clearfix>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Overlay
          show={showDelete}
          target={this.containerRef.current}
          placement="top"
          rootClose
          onHide={this.closeDelete}
        >
          <Popover style={{ zIndex: 1200 }}>
            <div className="text-center">{messages.are_you_sure}</div>

            <div style={{ width: '140px' }}>
              <ButtonGroup className="m-t-10" justified>
                <Button style={{ width: '49%' }} bsSize="sm" className="p-l-5 p-r-5" onClick={this.closeDelete}>
                  {messages.no}
                </Button>
                <Button
                  style={{ width: '49%' }}
                  bsSize="sm"
                  className="p-l-5 p-r-5"
                  bsStyle="danger"
                  onClick={this.doDelete}
                >
                  {messages.delete}
                </Button>
              </ButtonGroup>
            </div>
          </Popover>
        </Overlay>
      </>
    );
  }
}

export default injectIntl(CmsMediaSelectorFilePreview);
